import { Container, Divider, Grid, Typography } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { BackspaceOutlined as BackspaceOutlinedIcon, Print as PrintIcon, Search as SearchIcon, CloudDownload } from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import SelectShedMovementType from '../../components/Form/SelectShedMovementType';
import Success from '../../components/Form/Success';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { MvmShedMovementSearch } from '../../interfaces/Mvm';
import ReportApi from '../../services/ReportApi';
import MovementTypeApi from '../../services/MovementTypeApi';
import getDefaultGridOptions, { defaultHeaderOptions } from '../../utils/componentUtils';
import permissions from '../../utils/Permissions';
import useKeypress from '../../utils/useKeypress';
import { useStyles } from '../Shed/Style';
import DateTimeField from '../../components/Form/Date'
import { MovementType } from '../../interfaces/MovementType';

const opcoes = [
    { url: '/Shed', descricao: 'Incluir', state: {openPanelOnLoad: true}},
    { url: '/Shed', descricao: 'Pesquisar', state: {}}
]

interface Params {
    openPanelOnLoad: boolean;
}

const ShedMovementReport: React.FC = () => {
    const classes = useStyles();
    const location = useLocation<Params>();
    const [shedsMovementReport, setShedsMovementReport] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const { user, hasPermission } = useAuth();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("ShedMovementReport");
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const [success] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!hasPermission(permissions.REPORTS.ShedMovement))
            history.replace('/NoPermission');

        var params: MovementType = {
            pageSize: 1000,
            plantId: Number(user.company.plantID),
            description: ""
        };
        MovementTypeApi.searchMovementType(params);
    }, [history, user]);

    
    //Campos do Form
    interface IFormInput {
        shed: any;
        shedMovementType: any;
        initialDate: Date | null;
        endDate: Date | null;
    }

    //Metodos do form:
    const { handleSubmit, reset, control, getValues, setValue } = useForm<IFormInput>({
        defaultValues: {
            shed: {},
            shedMovementType: {},
            initialDate: null,
            endDate: null
        }
    });

    const columns = [
        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'entriesQuantity',
            label: t('entriesQuantity'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'exitsQuantity',
            label: t('exitsQuantity'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'volumesQuantity',
            label: t('volumesQuantity'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'palletsVolumeQuantity',
            label: t('palletsVolumeQuantity'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'avarageStayTime',
            label: t('avarageStayTime'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'exceededExitStayTime',
            label: t('exceededExitStayTime'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'pendingControls',
            label: t('pendingControls'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },   
    ]

    useKeypress('Escape', () => {
    });

    useEffect(() => {
        setShedsMovementReport([]);
    }, []);

    const onSubmit = async (data: any) => {
        search(data);
    };

    function validateReportRequestNullFields(data: any) {
        return (
            data.shed == null ||
            data.shedMovementType == null ||
            !data.initialDate ||
            !data.endDate ||
            data.initialDate === "" ||
            data.endDate === ""
            )
    }

    function search(data: any) {
        setShedsMovementReport([])
        
        if (validateReportRequestNullFields(data)) {
            enqueueSnackbar(_t("requiredFieldsValidation"), { variant: 'warning' });
            return;
        }
        setLoading(true);

        var params: MvmShedMovementSearch = {
            shedId: data.shed.code,
            companyId: +user.company.companyID,
            plantId: +user.company.plantID,
            movementTypeId: data.shedMovementType.code,
            initialDate: data.initialDate,
            endDate: data.endDate
        }

        ReportApi.searchMvmShedMovement(params)
            .then(result => {
                if (result) {
                    setShedsMovementReport([result]);
                }
                else {
                    setShedsMovementReport([]);
                }
            }).catch(() => {
                setShedsMovementReport([]);
            }).finally(() => {
                setLoading(false);
            });
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: shedsMovementReport?.items ? 'pointer' : ''
                }
            }
        }
    })

    // REPORTTYPE 1 = PDF, 2 = EXCEL
    function generateReport(data: any, reportType: string) {
        if (validateReportRequestNullFields(data)) {
            enqueueSnackbar(_t("requiredFieldsValidation"), { variant: 'warning' });
            return;
        }

        var params: MvmShedMovementSearch = {
            shedId: data.shed.code,
            companyId: +user.company.companyID,
            plantId: +user.company.plantID,
            movementTypeId: data.shedMovementType.code,
            initialDate: data.initialDate,
            endDate: data.endDate,
            userName: user.name,
            renderType: reportType
        }

        ReportApi.printMvmShedMovementReport(params);
    }

    useEffect(() => {
        if (location.state?.openPanelOnLoad)
        {
        }
    }, [location.state?.openPanelOnLoad])
    
    if (success)
        return (
            <Container maxWidth={false} component="main">
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        <Success opcoes={opcoes}/>
                    </div>
                </div>
            </Container>
        )
    else
    return (
        <Container maxWidth={false} component="main">
            <PageTitle title={t("pageTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(onSubmit)}  >

                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearch")}
                                </Typography>

                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI 
                                    onClick={() => reset()} 
                                    startIcon={<BackspaceOutlinedIcon />}
                                >
                                    {_t("clean")}
                                </ButtonUI>

                                <ButtonUI 
                                    type="submit"
                                    color="primary" 
                                    disabled={!hasPermission(permissions.REPORTS.ShedMovement)} 
                                    startIcon={<SearchIcon />}
                                    >
                                        {_t("search")}
                                </ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>
                            <SelectShedMovementType
                                    userName={user.userName}
                                    nameSelectShed={"shed"}
                                    nameSelectMovementType={"shedMovementType"}
                                    control={control}
                                    setValue={setValue}
                                    showConfirmButton={false}
                                />
                            <Grid item xs={2}>
                                <DateTimeField
                                    label={t("initialDate")} 
                                    name="initialDate" 
                                    control={control} 
                                    InputLabelProps={{shrink:true}}
                                    fullWidth
                                    dateAndTime />                                
                            </Grid>

                            <Grid item xs={2}>
                                <DateTimeField
                                    label={t("endDate")} 
                                    name="endDate" 
                                    control={control} 
                                    InputLabelProps={{shrink:true}}
                                    fullWidth
                                    dateAndTime />                                  
                            </Grid>

                            <Grid item xs={8}>
                            </Grid>

                        </Grid>
                    </form>
                    {
                        loading ? <LoadingUI /> :
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={shedsMovementReport}
                                    columns={columns}
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                    }}
                                />
                            </MuiThemeProvider>
                    }

                    {
                        shedsMovementReport.length > 0 &&
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <ButtonUI
                                    style={{marginLeft: 0}}
                                    disabled={!hasPermission(permissions.REPORTS.ShedMovement)} 
                                    color="primary"
                                    onClick={() => generateReport(getValues(), '1')} 
                                    startIcon={<PrintIcon />}
                                >
                                        {t("generateReport")}
                                </ButtonUI>
                                <ButtonUI
                                    style={{marginLeft: 0}}
                                    disabled={!hasPermission(permissions.REPORTS.ShedMovement)} 
                                    color="primary"
                                    onClick={() => generateReport(getValues(), '2')} 
                                    startIcon={<CloudDownload />}
                                >
                                        {_t("exportExcel")}
                                </ButtonUI>
                            </Grid>
                        </Grid>
                    }

                </div>
            </div>
        </Container>
    )
}
export default ShedMovementReport;
